module.exports = __webpack_public_path__ + "static/media/video2.7f056654.mp4";